import React from "react";
import { Layout } from "antd";
import SponsorTNav from "./SponsorTNav";

import { Outlet } from "react-router-dom";
import { COLORS } from "../../../Config/Colors";
const { Content } = Layout;
const SponsorTLayout = () => {
  return (
    <Layout>
      <div style={{ backgroundColor: COLORS.GREY }}>
        <SponsorTNav />
      </div>
      <Content>
        <Outlet />
      </Content>
      {/* <Footer style={{ backgroundColor: "#2F89FC" }}>
        <HomeFooter />
      </Footer> */}
    </Layout>
  );
};
export default SponsorTLayout;
